import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './assets/js/jquery.js';
import './assets/js/jquery.easing.1.3.js';
import './assets/js/bootstrap.min.js';
import './assets/js/jquery.fancybox.pack.js';
import './assets/js/jquery.fancybox-media.js';
import './assets/js/portfolio/jquery.quicksand.js';
import './assets/js/portfolio/setting.js';
import './assets/js/jquery.flexslider.js';
import './assets/js/animate.js';
import './assets/js/custom.js';
import './assets/js/owl-carousel/owl.carousel.js';
import './assets/js/easypiechart/easypiechart.min.js';
import './assets/js/nivo-lightbox.js';
import './assets/js/main.js';
import './assets/js/bootstrap-hover-dropdown.min.js';
import './assets/js/jquery.isotope.min.js';
import './assets/js/jquery.magnific-popup.min.js';

import './assets/css/bootstrap.min.css';
import './assets/simple-line-icons/css/simple-line-icons.css';
import './assets/css/fancybox/jquery.fancybox.css';
import './assets/css/flexslider.css';
import './assets/js/owl-carousel/owl.carousel.css';
import './assets/css/style.css';

// Vue.config.productionTip = false
// Vue.prototype.$jquery = jquery;
// Vue.prototype.$easing = easing;
// Vue.prototype.$bootstrap = bootstrap;
// Vue.prototype.$fancybox = fancybox;
// Vue.prototype.$fancyboxMedia = fancyboxMedia;
// Vue.prototype.$quicksand = quicksand;
// Vue.prototype.$setting = setting;
// Vue.prototype.$flexslider = flexslider;
// Vue.prototype.$animate = animate;
// Vue.prototype.$custom = custom;
// Vue.prototype.$carousel = carousel;
// Vue.prototype.$easypiechart = easypiechart;
// Vue.prototype.$lightbox = lightbox;
// Vue.prototype.$main = main;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
